import { FC, useState, useEffect } from 'react';

interface Event {
	id: number;
	title: string;
	date: string;
	description: string;
}

interface ListViewProps {
	events: Event[];
	eventsPerPage: number;
	onEventClick: (event: Event) => void;
}

const ListView: FC<ListViewProps> = ({ events, eventsPerPage, onEventClick }) => {
	const [displayedEvents, setDisplayedEvents] = useState<Event[]>([]);
	const [hasMoreEvents, setHasMoreEvents] = useState<boolean>(false);

	useEffect(() => {
		setDisplayedEvents(events.slice(0, eventsPerPage));
		setHasMoreEvents(events.length > eventsPerPage);
	}, [events, eventsPerPage]);

	const handleLoadMore = () => {
		const newDisplayedEvents = events.slice(0, displayedEvents.length + eventsPerPage);
		setDisplayedEvents(newDisplayedEvents);
		setHasMoreEvents(newDisplayedEvents.length < events.length);
	};

	// Helper function to format the date and time
	const formatDateTime = (dateString: string) => {
		const date = new Date(dateString);
		const options: Intl.DateTimeFormatOptions = {
			weekday: 'long',
			month: 'long',
			day: 'numeric',
		};
		const formattedDate = date.toLocaleDateString('en-US', options).replace(',', '');
		const formattedTime = date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: false });

		return `${formattedDate} at ${formattedTime}`;
	};

	return (
		<div className="fsdpe-calendar-wrapper__views__list">
			{displayedEvents.length === 0 ? (
				<p>No events this month</p>
			) : (
				<ul>
					{displayedEvents.map((event) => (
						<li className="fsdpe-calendar-wrapper__views__list__item"
							key={event.id}>
							<strong>{event.title}</strong>
							<p>{formatDateTime(event.date)}</p>
							<p onClick={() => onEventClick(event)}
							   style={{
								   cursor: 'pointer'
							   }}
							>
								Show details
							</p>
						</li>
					))}
				</ul>
			)}

			{hasMoreEvents && (
				<button
					className={"fsdpe-calendar-wrapper__btn"}
					style={{
						display: 'block',
						marginLeft: 'auto',
						marginRight: 'auto',
						marginTop: '32px'
					}}
					onClick={handleLoadMore}>
					Load More
				</button>
			)}
		</div>
	);
};

export default ListView;
